import './VisualizationsHeader.scss';

export { default } from './VisualizationsHeader';
